import React from 'react';

export function ClockIcon() {
  // https://lucide.dev/icons/clock
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </g>
  );
}
